import type { StateMapping, UiState } from "instantsearch.js"

type RouterState = {
  query?: string
  category?: string[]
  material?: string[]
  lcaFirstLifeRating?: string[]
  upholstery?: string
  brandNew?: boolean
  page?: number
  sortBy?: string
  outdoor?: boolean
  indoor?: boolean
  stackable?: boolean
  sustainable?: boolean
  satellietOriginals?: boolean
  priceMin?: number
  priceMax?: number
}

export function createStateMapping(
  indexName: keyof UiState,
  lcaFilterEnabled: boolean,
  materialFilterEnabled: boolean,
  priceSearchEnabled: boolean,
  upholsteryFilterEnabled: boolean,
  priceAttribute: string
): StateMapping<UiState, RouterState> {
  return {
    stateToRoute(uiState): RouterState {
      const indexUiState = uiState[indexName] || {}

      const priceRange =
        priceSearchEnabled && indexUiState.range?.[priceAttribute]
          ? String(indexUiState.range[priceAttribute]).split(":")
          : undefined

      return {
        query: indexUiState.query,
        category: indexUiState.refinementList?.category_plural,
        material: materialFilterEnabled ? indexUiState.refinementList?.material : undefined,
        lcaFirstLifeRating: lcaFilterEnabled
          ? indexUiState.refinementList?.lca_first_life_rating
          : undefined,
        upholstery: upholsteryFilterEnabled ? indexUiState.menu?.has_upholstery : undefined,
        brandNew: indexUiState.toggle?.brand_new,
        outdoor: indexUiState.toggle?.outdoor,
        indoor: indexUiState.toggle?.indoor,
        stackable: indexUiState.toggle?.stackable,
        sustainable: indexUiState.toggle?.sustainable,
        satellietOriginals: indexUiState.toggle?.satelliet_originals,
        priceMin: priceRange?.[0] ? Number(priceRange[0]) : undefined,
        priceMax: priceRange?.[1] ? Number(priceRange[1]) : undefined,
        page: indexUiState.page,
        sortBy: indexUiState.sortBy,
      }
    },
    routeToState(routeState: RouterState = {}) {
      return {
        [indexName]: {
          query: routeState.query,
          refinementList: {
            category_plural: routeState.category,
            material: materialFilterEnabled ? routeState.material : undefined,
            lca_first_life_rating: lcaFilterEnabled ? routeState.lcaFirstLifeRating : undefined,
          },
          menu: {
            has_upholstery: upholsteryFilterEnabled ? routeState.upholstery : undefined,
          },
          toggle: {
            brand_new: routeState.brandNew,
            outdoor: routeState.outdoor,
            indoor: routeState.indoor,
            stackable: routeState.stackable,
            sustainable: routeState.sustainable,
            satelliet_originals: routeState.satellietOriginals,
          },
          range: {
            ...(priceSearchEnabled && (routeState.priceMin != null || routeState.priceMax != null)
              ? {
                  [priceAttribute]: `${routeState.priceMin ?? ""}:${routeState.priceMax ?? ""}`,
                }
              : {}),
          },
          page: routeState.page,
          sortBy: routeState.sortBy || indexName,
        },
      } as UiState
    },
  }
}
